export function getElementsPositionToRootWindow(element, offsetPosition = {}, callback) {
  let offset = 0;
  const elementsRect = element.getBoundingClientRect();
  if (offsetPosition.center) {
    offset = document.documentElement.clientHeight / 2 - elementsRect.height / 2;
  }
  if (offsetPosition.quarter) {
    offset = document.documentElement.clientHeight / 4;
  }
  if (offsetPosition.oneSixth) {
    offset = document.documentElement.clientHeight / 6;
  }
  if (offsetPosition.top) {
    offset = document.documentElement.clientHeight / 10;
  }
  callback(elementsRect.top - offset);
}
